import React, { useState, useRef } from 'react';
import { Dialog, Stack, Typography, IconButton, Tabs, Tab, Box, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import PropTypes from 'prop-types';
import TabLayout from '../../../../components/TabLayout';
import ActivityLog from '../../../../components/ActivityLog';
import CompanyDetails from './CompanyDetails';
import BlockAndUnblockCompany from './BlockAndUnblockCompany';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import Transition from '../../../../components/Transition';
import AddEditCompany from './AddEditCompany';
import Traders from './Traders';
import { CancelToken } from 'apisauce';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

/**
 * dialog style
 */
const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

/**
 * Validation Schema
 */

export default function ViewCompany({ modelOpen, onModelHandleClose, companyId, type }) {
  const handleClose = () => {
    onModelHandleClose(false);
  };

  const [openBlockDialog, SetOpenBlockDialog] = useState(false);
  const [tabIndexValue, setValue] = React.useState(0);

  const [companyDetails, setCompanyDetails] = useState([]);
  const [openAddCompany, setOpenAddCompany] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);

  let source = CancelToken.source();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // setCompanyManagementList([]);
    // setPayload((prev) => ({ ...prev, limt: 10, paginationPage: 0, page: 1, filter: null }));
  };

  const getCompanyDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`company/details/${companyId}`,{},{
      cancelToken: source.token
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        // data?.data?.document?.map((item, index) => {
        //   // item.startDate = moment(new Date(item.startDate)).format('DD MMM YYYY');
        //   // item.expiryDate = moment(new Date(item.expiryDate)).format('DD MMM YYYY');
        // });
        setCompanyDetails(data?.response);
      }
      setLoading(false);
    } else {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getCompanyDetails();
    return () => {
      if(source) {
        source.cancel();
      }
    }
  }, [])



  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // TransitionComponent={Transition}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        className="!h-[100%]"
        style={{}}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="sticky top-[0] !bg-[#ffffff] z-[9] h-[56px]"
          style={{ paddingLeft: '24px', paddingRight: '24px', borderBottomWidth: 1, borderBottomColor: '#0000000D' }}
        >
          <Tabs
            indicatorColor="primary"
            value={tabIndexValue}
            onChange={handleChange}
          >
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="COMPANY DETAILS"
              {...a11yProps(0)}
            />
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="TRADERS"
              {...a11yProps(1)}
            />
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="ACTIVITY LOG"
              {...a11yProps(1)}
            />
          </Tabs>
          <div>
            {tabIndexValue === 0 && (
              <>
                <Tooltip
                  disableInteractive
                  title={companyDetails?.status === '1' ? 'Block Company' : 'Unblock Company'}
                >
                  <IconButton onClick={() => SetOpenBlockDialog(true)}>
                    <BlockIcon style={{ transform: 'scale(1.143)', color: companyDetails?.status === '1' ? '#B11B1B' : '#00A632', width: '18px', height: '18px' }} />
                  </IconButton>
                </Tooltip>
                {companyDetails?.status === '1' && type === 0 && (
                  <>
                    <Tooltip
                      disableInteractive
                      title="Edit Company"
                    >
                      <IconButton onClick={() => setOpenAddCompany(true)}>
                        <EditIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '18px', height: '18px' }} />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </>
            )}
            <Tooltip
              disableInteractive
              title="Close"
            >
              <IconButton onClick={() => onModelHandleClose(refresh)}>
                <ClearIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '22px', height: '22px' }} />
              </IconButton>
            </Tooltip>
          </div>
        </Stack>
        <TabLayout>
          <TabPanel
            className="!p-[0px]"
            value={tabIndexValue}
            index={0}
          >
            {tabIndexValue === 0 ? (
              <CompanyDetails
                isLoading={loading}
                details={companyDetails}
              />
            ) : null}
          </TabPanel>
          <TabPanel
            value={tabIndexValue}
            index={1}
          >
            {tabIndexValue === 1 ? <Traders type={type} details={companyDetails} isLoading={loading} /> : null}
          </TabPanel>
          <TabPanel
            value={tabIndexValue}
            index={2}
          >
            {tabIndexValue === 2 ? (
              <ActivityLog
                refId={companyId}
                type={'Company'}
              />
            ) : null}
          </TabPanel>
        </TabLayout>
      </Stack>
      {openBlockDialog && (
        <BlockAndUnblockCompany
          handleClose={(event) => {
            if (event) {
              setRefresh(true);
              getCompanyDetails();
            }
            SetOpenBlockDialog(false);
          }}
          open={openBlockDialog}
          isBlockedStatus={companyDetails?.status}
          companyId={companyDetails?._id}
        />
      )}

      {openAddCompany ? (
        <AddEditCompany
          onModelHandleClose={(event) => {
            if (event) {
              setRefresh(true);
              getCompanyDetails();
            }
            setOpenAddCompany(false);
          }}
          modelOpen={openAddCompany}
          companyDetails={companyDetails}
        />
      ) : null}
    </Dialog>
  );
}
